import styled from "styled-components";
import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Flex} from "./StyleComponents";
import {inject, observer} from "mobx-react";
import i18n from "i18next";

const StepperStyled = styled(Flex)`
    max-height:80px;
    align-items: center;
    justify-content: center;
    background:#282c34;
    color: white;
    ul{
        list-style: none;
            margin: 30px;
        li{
          display:inline-block;
          margin:0 10px;
          cursor: pointer;
        }
    }
    
    svg{
        margin-left: ${({uiStore}: any) => uiStore.isRTL ? '0' : '14px'};
        margin-right: ${({uiStore}: any) => uiStore.isRTL ? '14px' : '0'};
    }
`;

const LiStyled = styled.li`
    color: ${({uiStore, step}: any) => uiStore.stepperState < step ? "#989898ab" : 'white'};
`;

const LiStyledObserver = observer(({isRTL, ...props}) => (
    <LiStyled {...props} isRTL={isRTL}>{props.children}</LiStyled>));

const Stepper = inject("uiStore")(observer((props: any) => {

    const iconName: any = `chevron-${props.uiStore.isRTL ? 'left' : 'right'}`;
    return (
        <StepperStyled {...props}
                       data={props.uiStore.stepperState}
                       dir={props.uiStore.dir}>
            <ul>
                <LiStyledObserver {...props}
                                  step='1'
                                  isRTL={props.uiStore.isRTL}
                                  onClick={() => props.setStep(1)}>
                    {i18n.t("Campaign config")}
                    <FontAwesomeIcon icon={iconName}/>
                </LiStyledObserver>
                <LiStyledObserver {...props}
                                  step='2'
                                  isRTL={props.uiStore.isRTL}
                                  onClick={() => props.setStep(2)}>
                    {i18n.t("Edit template")}
                    <FontAwesomeIcon icon={iconName}/>
                </LiStyledObserver>
                <LiStyledObserver {...props}
                                  step='3'
                                  isRTL={props.uiStore.isRTL}
                                  onClick={() => props.setStep(3)}>
                    {i18n.t("Sending")}
                </LiStyledObserver>
            </ul>
        </StepperStyled>
    );
}));

export default Stepper;

